import { useNavigate, useParams } from 'react-router-dom';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useShowTrailById } from '@/data/corporate-university/trails';
import { CoursesList } from '@/packages/corporate-university/components/courses-list';

export const TrailsById = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { trail, isLoading } = useShowTrailById(id!);

  return (
    <PageContainer>
      <PageHeader
        title={trail?.name}
        backNavigationText="Voltar"
        handleBackNavigation={() => navigate(-1)}
      />
      <CoursesList
        courses={trail?.courses.map((course) => course.course) ?? []}
        isLoading={isLoading}
        goToTrails={() => navigate('/corporate-university')}
      />
    </PageContainer>
  );
};
